export const allAgendas = [
	{
		start: "2021-10-25 08:50:00+01:00",
		end: "2021-10-25 09:00:00+01:00",
		title: "Official opening and welcome",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-25 09:00:00+01:00",
		end: "2021-10-25 10:00:00+01:00",
		title: "Brian Cox: Is information the foundation of reality?",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-25 13:00:00+01:00",
		end: "2021-10-25 13:30:00+01:00",
		title: "Getting the most from the ISF",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-25 13:00:00+01:00",
		end: "2021-10-25 13:30:00+01:00",
		title: "OneTrust",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-25 13:30:00+01:00",
		end: "2021-10-25 14:00:00+01:00",
		title: "BitSight - Third party risk management with security ratings",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-25 13:30:00+01:00",
		end: "2021-10-25 14:00:00+01:00",
		title: "ISF Security Assessment and Roadmap",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-25 14:00:00+01:00",
		end: "2021-10-25 15:00:00+01:00",
		title: "Steve Wozniak in conversation with Steve Durbin",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-25 15:00:00+01:00",
		end: "2021-10-25 16:30:00+01:00",
		title: "4.5 Supply Chain Security: Interactive training workshop - Part 1",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-25 16:00:00+01:00",
		end: "2021-10-25 17:30:00+01:00",
		title: "5.3 Translating Risk: An ISF Learning Espresso session",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-25 16:00:00+01:00",
		end: "2021-10-25 17:30:00+01:00",
		title: "5.5 Threat Horizon 2024 workshop",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-25 17:00:00+01:00",
		end: "2021-10-25 17:30:00+01:00",
		title: "ISF round up",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-25 17:00:00+01:00",
		end: "2021-10-25 17:30:00+01:00",
		title: "KPMG - Understanding the real impact of an industrial cyber-attack with hands-on example",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-25 17:30:00+01:00",
		end: "2021-10-25 17:50:00+01:00",
		title: "Exclusive magic show",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-25 17:50:00+01:00",
		end: "2021-10-25 18:00:00+01:00",
		title: "Official opening and welcome",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-25 18:00:00+01:00",
		end: "2021-10-25 19:00:00+01:00",
		title: "Brian Cox: Is information the foundation of reality?",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-25 21:00:00+01:00",
		end: "2021-10-25 22:00:00+01:00",
		title: "Steve Wozniak in conversation with Steve Durbin",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-26 01:50:00+01:00",
		end: "2021-10-26 02:00:00+01:00",
		title: "Official opening and welcome",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-26 02:00:00+01:00",
		end: "2021-10-26 03:00:00+01:00",
		title: "Brian Cox: Is information the foundation of reality?",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-26 06:00:00+01:00",
		end: "2021-10-26 07:00:00+01:00",
		title: "Steve Wozniak in conversation with Steve Durbin",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-26 09:00:00+01:00",
		end: "2021-10-26 10:00:00+01:00",
		title: "Viviane Reding: The future of digital governance",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-26 14:00:00+01:00",
		end: "2021-10-26 15:00:00+01:00",
		title: "Rachel Botsman: Rethinking Trust",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-26 18:00:00+01:00",
		end: "2021-10-26 19:00:00+01:00",
		title: "Viviane Reding: The future of digital governance",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-26 21:00:00+01:00",
		end: "2021-10-26 22:00:00+01:00",
		title: "Rachel Botsman: Rethinking Trust",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-26 13:00:00+01:00",
		end: "2021-10-26 13:30:00+01:00",
		title: "Huawei Technologies",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-26 13:00:00+01:00",
		end: "2021-10-26 13:30:00+01:00",
		title: "SentinelOne - The genesis of XDR: Why simplification is key to the future of threat prevention",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-26 13:30:00+01:00",
		end: "2021-10-26 14:00:00+01:00",
		title: "ImmuniWeb - Consolidating ASM, CSPM and DFIR to cut costs and boost efficiency",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-26 13:30:00+01:00",
		end: "2021-10-26 14:00:00+01:00",
		title: "SureCloud - The evolution of IT compliance: Developing a continuous compliance programme",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-26 17:00:00+01:00",
		end: "2021-10-26 17:30:00+01:00",
		title: "BeyondTrust - Endpoint privilege management demonstration",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-26 17:00:00+01:00",
		end: "2021-10-26 17:30:00+01:00",
		title: "IBM Security - Reduce the risk of insider threat with zero trust",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-26 17:30:00+01:00",
		end: "2021-10-26 18:00:00+01:00",
		title: "CybelAngel - Secure your digital world with CybelAngel",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-26 17:30:00+01:00",
		end: "2021-10-26 18:00:00+01:00",
		title: "SecurityScorecard - Security Ratings in action",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-26 07:00:00+01:00",
		end: "2021-10-26 08:30:00+01:00",
		title: "4.5 Supply Chain Security: Interactive training workshop - Part 1",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-26 07:00:00+01:00",
		end: "2021-10-26 08:30:00+01:00",
		title: "4.6 Threat Horizon 2024 workshop",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-26 08:00:00+01:00",
		end: "2021-10-26 09:30:00+01:00",
		title: "5.3 Translating Risk: An ISF Learning Espresso session",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-26 12:00:00+01:00",
		end: "2021-10-26 13:30:00+01:00",
		title: "8.5 Surviving an extinction level attack workshop",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-26 15:00:00+01:00",
		end: "2021-10-26 16:00:00+01:00",
		title: "9.3 ISF Standard of Good Practice: exploring the new SOGP WebApp",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-26 15:00:00+01:00",
		end: "2021-10-26 16:30:00+01:00",
		title: "9.5 Supply Chain Security: Interactive training workshop - Part 2",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-26 22:00:00+01:00",
		end: "2021-10-26 23:30:00+01:00",
		title: "8.5 Translating Risk: An ISF Learning Espresso session",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-26 23:00:00+01:00",
		end: "2021-10-26 23:59:00+01:00",
		title: "9.3 ISF Standard of Good Practice: exploring the new SOGP WebApp",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-26 01:00:00+01:00",
		end: "2021-10-26 01:30:00+01:00",
		title: "Getting the most from the ISF",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-26 13:00:00+01:00",
		end: "2021-10-26 13:30:00+01:00",
		title: "Cyber Awareness – ISF resources to engage audiences",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-26 13:30:00+01:00",
		end: "2021-10-26 14:00:00+01:00",
		title: "KPMG Drop in - Accelerating cyber innovation",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-26 17:00:00+01:00",
		end: "2021-10-26 17:30:00+01:00",
		title: "Getting the most from the ISF",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-26 17:00:00+01:00",
		end: "2021-10-26 17:30:00+01:00",
		title: "ISF round up",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-26 17:30:00+01:00",
		end: "2021-10-26 17:50:00+01:00",
		title: "Exclusive magic show",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 01:00:00+01:00",
		end: "2021-10-27 02:00:00+01:00",
		title: "Viviane Reding: The future of digital governance",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 05:00:00+01:00",
		end: "2021-10-27 05:30:00+01:00",
		title: "ISF Security Assessment and Roadmap",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 05:30:00+01:00",
		end: "2021-10-27 06:00:00+01:00",
		title: "Cyber Awareness – ISF resources to engage audiences",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 06:00:00+01:00",
		end: "2021-10-27 07:00:00+01:00",
		title: "Rachel Botsman: Rethinking Trust",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 07:00:00+01:00",
		end: "2021-10-27 08:00:00+01:00",
		title: "9.3 ISF Standard of Good Practice: exploring the new SOGP WebApp",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 07:00:00+01:00",
		end: "2021-10-27 08:30:00+01:00",
		title: "9.5 Supply Chain Security: Interactive training workshop - Part 2",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 09:00:00+01:00",
		end: "2021-10-27 10:30:00+01:00",
		title: "11.5 Surviving an extinction level attack workshop",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 11:00:00+01:00",
		end: "2021-10-27 12:00:00+01:00",
		title: "13.5 Backdoors and breaches: Cyber security exercise",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 12:00:00+01:00",
		end: "2021-10-27 13:00:00+01:00",
		title: "Sadie Creese: Ransomware: past, present and future",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 13:00:00+01:00",
		end: "2021-10-27 13:30:00+01:00",
		title: "Crowdstrike",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 13:00:00+01:00",
		end: "2021-10-27 13:30:00+01:00",
		title: "ISF QIRA Demonstration",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 13:00:00+01:00",
		end: "2021-10-27 13:30:00+01:00",
		title: "ISF Security Assessment and Roadmap",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 13:00:00+01:00",
		end: "2021-10-27 13:30:00+01:00",
		title: "Synopsys",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 13:30:00+01:00",
		end: "2021-10-27 14:00:00+01:00",
		title: "Cyber Awareness – ISF resources to engage audiences",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 13:30:00+01:00",
		end: "2021-10-27 14:00:00+01:00",
		title: "Keysight Technologies",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 13:30:00+01:00",
		end: "2021-10-27 14:00:00+01:00",
		title: "KPMG Drop in - Why we should invest in Identity Management",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 13:30:00+01:00",
		end: "2021-10-27 14:00:00+01:00",
		title: "Veracode - How to speed up AppSec testing?",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 14:00:00+01:00",
		end: "2021-10-27 15:00:00+01:00",
		title: "14.4 Information security in Mergers and Acquisitions",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 16:00:00+01:00",
		end: "2021-10-27 17:00:00+01:00",
		title: "Max McKeown: How to adapt and thrive in an age of opportunities, shocks, and change",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 17:00:00+01:00",
		end: "2021-10-27 17:30:00+01:00",
		title: "ISF round up",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 17:15:00+01:00",
		end: "2021-10-27 17:45:00+01:00",
		title: "Crossword CyberSecurity - Stay on top of cyber security and supply chain risk with Rizikon Assurance",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 17:15:00+01:00",
		end: "2021-10-27 17:45:00+01:00",
		title: "KPMG Drop in - From enforcer to influencer: earning your spot in the C Suite ",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 17:15:00+01:00",
		end: "2021-10-27 17:45:00+01:00",
		title: "Tessian",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 20:00:00+01:00",
		end: "2021-10-27 21:00:00+01:00",
		title: "Sadie Creese: Ransomware: past, present and future",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 21:00:00+01:00",
		end: "2021-10-27 22:00:00+01:00",
		title: "13.5 Backdoors and breaches: Cyber security exercise",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 22:00:00+01:00",
		end: "2021-10-27 23:00:00+01:00",
		title: "14.4 Information security in Mergers and Acquisitions",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 01:00:00+01:00",
		end: "2021-10-27 02:00:00+01:00",
		title: "Viviane Reding: The future of digital governance",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 05:00:00+01:00",
		end: "2021-10-27 05:30:00+01:00",
		title: "ISF Security Assessment and Roadmap",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 05:30:00+01:00",
		end: "2021-10-27 06:00:00+01:00",
		title: "Cyber Awareness – ISF resources to engage audiences",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 06:00:00+01:00",
		end: "2021-10-27 07:00:00+01:00",
		title: "Rachel Botsman: Rethinking Trust",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 07:00:00+01:00",
		end: "2021-10-27 08:00:00+01:00",
		title: "9.3 ISF Standard of Good Practice: exploring the new SOGP WebApp",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 07:00:00+01:00",
		end: "2021-10-27 08:30:00+01:00",
		title: "9.5 Supply Chain Security: Interactive training workshop - Part 2",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 09:00:00+01:00",
		end: "2021-10-27 10:30:00+01:00",
		title: "11.5 Surviving an extinction level attack workshop",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 11:00:00+01:00",
		end: "2021-10-27 12:00:00+01:00",
		title: "13.5 Backdoors and breaches: Cyber security exercise",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 12:00:00+01:00",
		end: "2021-10-27 13:00:00+01:00",
		title: "Sadie Creese: Ransomware: past, present and future",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 13:00:00+01:00",
		end: "2021-10-27 13:30:00+01:00",
		title: "Crowdstrike",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 13:00:00+01:00",
		end: "2021-10-27 13:30:00+01:00",
		title: "ISF QIRA Demonstration",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 13:00:00+01:00",
		end: "2021-10-27 13:30:00+01:00",
		title: "ISF Security Assessment and Roadmap",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 13:00:00+01:00",
		end: "2021-10-27 13:30:00+01:00",
		title: "Synopsys",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 13:30:00+01:00",
		end: "2021-10-27 14:00:00+01:00",
		title: "Cyber Awareness – ISF resources to engage audiences",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 13:30:00+01:00",
		end: "2021-10-27 14:00:00+01:00",
		title: "Keysight Technologies",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 13:30:00+01:00",
		end: "2021-10-27 14:00:00+01:00",
		title: "KPMG Drop in - Why we should invest in Identity Management",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 13:30:00+01:00",
		end: "2021-10-27 14:00:00+01:00",
		title: "Veracode - How to speed up AppSec testing?",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 14:00:00+01:00",
		end: "2021-10-27 15:00:00+01:00",
		title: "14.4 Information security in Mergers and Acquisitions",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 16:00:00+01:00",
		end: "2021-10-27 17:00:00+01:00",
		title: "Max McKeown: How to adapt and thrive in an age of opportunities, shocks, and change",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 17:00:00+01:00",
		end: "2021-10-27 17:30:00+01:00",
		title: "ISF round up",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 17:15:00+01:00",
		end: "2021-10-27 17:45:00+01:00",
		title: "Crossword CyberSecurity - Stay on top of cyber security and supply chain risk with Rizikon Assurance",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 17:15:00+01:00",
		end: "2021-10-27 17:45:00+01:00",
		title: "KPMG Drop in - From enforcer to influencer: earning your spot in the C Suite ",
		room: "Interactive lounge",
		path: "/lounge",
	},
	{
		start: "2021-10-27 17:15:00+01:00",
		end: "2021-10-27 17:45:00+01:00",
		title: "Tessian",
		room: "Exhibition hall, Sponsor theatre",
		path: "/sponsor-theatre",
	},
	{
		start: "2021-10-27 20:00:00+01:00",
		end: "2021-10-27 21:00:00+01:00",
		title: "Sadie Creese: Ransomware: past, present and future",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-27 21:00:00+01:00",
		end: "2021-10-27 22:00:00+01:00",
		title: "13.5 Backdoors and breaches: Cyber security exercise",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-27 22:00:00+01:00",
		end: "2021-10-27 23:00:00+01:00",
		title: "14.4 Information security in Mergers and Acquisitions",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-28 00:00:00+01:00",
		end: "2021-10-28 01:00:00+01:00",
		title: "Max McKeown: How to adapt and thrive in an age of opportunities, shocks, and change",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-28 04:00:00+01:00",
		end: "2021-10-28 05:00:00+01:00",
		title: "Sadie Creese: Ransomware: past, present and future",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-28 06:00:00+01:00",
		end: "2021-10-28 07:00:00+01:00",
		title: "14.4 Information security in Mergers and Acquisitions",
		room: "Exploration zone",
		path: "/exploration-zone",
	},
	{
		start: "2021-10-28 08:00:00+01:00",
		end: "2021-10-28 09:00:00+01:00",
		title: "Max McKeown: How to adapt and thrive in an age of opportunities, shocks, and change",
		room: "Auditorium",
		path: "/auditorium",
	},
	{
		start: "2021-10-25T10:00+01:00",
		end: "2021-10-25T11:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "1.1 Doing the right thing: How TalkTalk helps customers to stay secure",
	},
	{
		start: "2021-10-25T11:00+01:00",
		end: "2021-10-25T12:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "2.1 Human centered security: Strengthening the weakest link",
	},
	{
		start: "2021-10-25T12:00+01:00",
		end: "2021-10-25T13:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "3.1 Improve your security posture: Expect more from your Internal Audit function",
	},
	{
		start: "2021-10-25T15:00+01:00",
		end: "2021-10-25T16:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "4.1 Tips for preparing and running a successful Security Healthcheck and Benchmarking assessment",
	},
	{
		start: "2021-10-25T16:00+01:00",
		end: "2021-10-25T17:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "5.1 Your guide to building a cyber security roadmap",
	},
	{
		start: "2021-10-25T19:00+01:00",
		end: "2021-10-25T20:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "1.1 Doing the right thing: How TalkTalk helps customers to stay secure",
	},
	{
		start: "2021-10-25T20:00+01:00",
		end: "2021-10-25T21:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "2.1 Human centered security: Strengthening the weakest link",
	},
	{
		start: "2021-10-25T22:00+01:00",
		end: "2021-10-25T23:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "3.1 Improve your security posture: Expect more from your Internal Audit function",
	},
	{
		start: "2021-10-25T23:00+01:00",
		end: "2021-10-25T23:59+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "4.1 Tips for preparing and running a successful Security Healthcheck and Benchmarking assessment",
	},
	{
		start: "2021-10-26T00:00+01:00",
		end: "2021-10-26T01:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "5.1 Your guide to building a cyber security roadmap",
	},
	{
		start: "2021-10-26T03:00+01:00",
		end: "2021-10-26T04:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "1.1 Doing the right thing: How TalkTalk helps customers to stay secure",
	},
	{
		start: "2021-10-26T04:00+01:00",
		end: "2021-10-26T05:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "2.1 Human centered security: Strengthening the weakest link",
	},
	{
		start: "2021-10-26T05:00+01:00",
		end: "2021-10-26T06:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "3.1 Improve your security posture: Expect more from your Internal Audit function",
	},
	{
		start: "2021-10-26T07:00+01:00",
		end: "2021-10-26T08:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "4.1 Tips for preparing and running a successful Security Healthcheck and Benchmarking assessment",
	},
	{
		start: "2021-10-26T08:00+01:00",
		end: "2021-10-26T09:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "5.1 Your guide to building a cyber security roadmap",
	},
	{
		start: "2021-10-26T10:00+01:00",
		end: "2021-10-26T11:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "6.1 Navigating safely through the storm: Proactively managing threats in the supply chain",
	},
	{
		start: "2021-10-26T11:00+01:00",
		end: "2021-10-26T12:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "7.1 Democratisation of IT: Embrace innovation while managing risk",
	},
	{
		start: "2021-10-26T12:00+01:00",
		end: "2021-10-26T13:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "8.1 Driving behaviour change: Developing a positive security awareness and education programme",
	},
	{
		start: "2021-10-26T15:00+01:00",
		end: "2021-10-26T16:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "9.1 My home is my castle: Implementing an information security strategy",
	},
	{
		start: "2021-10-26T16:00+01:00",
		end: "2021-10-26T17:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "10.1 Data Classification made simple: A show case of how it works in practice",
	},
	{
		start: "2021-10-26T19:00+01:00",
		end: "2021-10-26T20:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "6.1 Navigating safely through the storm: Proactively managing threats in the supply chain",
	},
	{
		start: "2021-10-26T20:00+01:00",
		end: "2021-10-26T21:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "7.1 Democratisation of IT: Embrace innovation while managing risk",
	},
	{
		start: "2021-10-26T22:00+01:00",
		end: "2021-10-26T23:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "8.1 Driving behaviour change: Developing a positive security awareness and education programme",
	},
	{
		start: "2021-10-26T23:00+01:00",
		end: "2021-10-26T23:59+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "9.1 My home is my castle: Implementing an information security strategy",
	},
	{
		start: "2021-10-27T00:00+01:00",
		end: "2021-10-27T01:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "10.1 Data Classification made simple: A show case of how it works in practice",
	},
	{
		start: "2021-10-27T02:00+01:00",
		end: "2021-10-27T03:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "6.1 Navigating safely through the storm: Proactively managing threats in the supply chain",
	},
	{
		start: "2021-10-27T03:00+01:00",
		end: "2021-10-27T04:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "7.1 Democratisation of IT: Embrace innovation while managing risk",
	},
	{
		start: "2021-10-27T04:00+01:00",
		end: "2021-10-27T05:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "8.1 Driving behaviour change: Developing a positive security awareness and education programme",
	},
	{
		start: "2021-10-27T07:00+01:00",
		end: "2021-10-27T08:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "9.1 My home is my castle: Implementing an information security strategy",
	},
	{
		start: "2021-10-27T08:00+01:00",
		end: "2021-10-27T09:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "10.1 Data Classification made simple: A show case of how it works in practice",
	},
	{
		start: "2021-10-27T09:00+01:00",
		end: "2021-10-27T10:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "11.1 Thwarting extortion: New and existing methods for ransomware detection and prevention",
	},
	{
		start: "2021-10-27T10:00+01:00",
		end: "2021-10-27T11:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "12.1 How does my organisation survive its move to the cloud?",
	},
	{
		start: "2021-10-27T11:00+01:00",
		end: "2021-10-27T12:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "13.1 Tessian - The paradigm shift of data-loss prevention: From rules-based to machine learning powered",
	},
	{
		start: "2021-10-27T14:00+01:00",
		end: "2021-10-27T15:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "14.1 Cyberterrorism: An emerging threat",
	},
	{
		start: "2021-10-27T15:00+01:00",
		end: "2021-10-27T16:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "15.1 Continuous compliance: Automating controls and enabling DevOps",
	},
	{
		start: "2021-10-27T18:00+01:00",
		end: "2021-10-27T19:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "11.1 Thwarting extortion: New and existing methods for ransomware detection and prevention",
	},
	{
		start: "2021-10-27T19:00+01:00",
		end: "2021-10-27T20:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "12.1 How does my organisation survive its move to the cloud?",
	},
	{
		start: "2021-10-27T21:00+01:00",
		end: "2021-10-27T22:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "13.1 Tessian - The paradigm shift of data-loss prevention: From rules-based to machine learning powered",
	},
	{
		start: "2021-10-27T22:00+01:00",
		end: "2021-10-27T23:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "14.1 Cyberterrorism: An emerging threat",
	},
	{
		start: "2021-10-27T23:00+01:00",
		end: "2021-10-27T23:59+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "15.1 Continuous compliance: Automating controls and enabling DevOps",
	},
	{
		start: "2021-10-28T02:00+01:00",
		end: "2021-10-28T03:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "11.1 Thwarting extortion: New and existing methods for ransomware detection and prevention",
	},
	{
		start: "2021-10-28T03:00+01:00",
		end: "2021-10-28T04:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "12.1 How does my organisation survive its move to the cloud?",
	},
	{
		start: "2021-10-28T05:00+01:00",
		end: "2021-10-28T06:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "13.1 Tessian - The paradigm shift of data-loss prevention: From rules-based to machine learning powered",
	},
	{
		start: "2021-10-28T06:00+01:00",
		end: "2021-10-28T07:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "14.1 Cyberterrorism: An emerging threat",
	},
	{
		start: "2021-10-28T07:00+01:00",
		end: "2021-10-28T08:00+01:00",
		room: "Breakout One",
		path: "/breakout-one",
		title: "15.1 Continuous compliance: Automating controls and enabling DevOps",
	},
	{
		start: "2021-10-25T10:00+01:00",
		end: "2021-10-25T11:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "1.2 Purple team operations, or, ensuring continuous security improvement",
	},
	{
		start: "2021-10-25T11:00+01:00",
		end: "2021-10-25T12:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "2.2 Addressing the multi-cloud security challenge: Lessons from the field",
	},
	{
		start: "2021-10-25T12:00+01:00",
		end: "2021-10-25T13:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "3.2 How to augment zero trust architecture using blockchain",
	},
	{
		start: "2021-10-25T15:00+01:00",
		end: "2021-10-25T16:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "4.2 Implementing an effective Information Security Awareness Campaign using a research based approach",
	},
	{
		start: "2021-10-25T16:00+01:00",
		end: "2021-10-25T17:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "5.2 Third party security risk management from humble beginnings",
	},
	{
		start: "2021-10-25T19:00+01:00",
		end: "2021-10-25T20:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "1.2 Purple team operations, or, ensuring continuous security improvement",
	},
	{
		start: "2021-10-25T20:00+01:00",
		end: "2021-10-25T21:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "2.2 Addressing the multi-cloud security challenge: Lessons from the field",
	},
	{
		start: "2021-10-25T22:00+01:00",
		end: "2021-10-25T23:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "3.2 How to augment zero trust architecture using blockchain",
	},
	{
		start: "2021-10-25T23:00+01:00",
		end: "2021-10-25T23:59+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "4.2 Implementing an effective Information Security Awareness Campaign using a research based approach",
	},
	{
		start: "2021-10-26T00:00+01:00",
		end: "2021-10-26T01:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "5.2 Third party security risk management from humble beginnings",
	},
	{
		start: "2021-10-26T03:00+01:00",
		end: "2021-10-26T04:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "1.2 Purple team operations, or, ensuring continuous security improvement",
	},
	{
		start: "2021-10-26T04:00+01:00",
		end: "2021-10-26T05:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "2.2 Addressing the multi-cloud security challenge: Lessons from the field",
	},
	{
		start: "2021-10-26T05:00+01:00",
		end: "2021-10-26T06:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "3.2 How to augment zero trust architecture using blockchain",
	},
	{
		start: "2021-10-26T07:00+01:00",
		end: "2021-10-26T08:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "4.2 Implementing an effective Information Security Awareness Campaign using a research based approach",
	},
	{
		start: "2021-10-26T08:00+01:00",
		end: "2021-10-26T09:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "5.2 Third party security risk management from humble beginnings",
	},
	{
		start: "2021-10-26T10:00+01:00",
		end: "2021-10-26T11:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "6.2 Backdoors and breaches: Simulating cyber security incidents",
	},
	{
		start: "2021-10-26T11:00+01:00",
		end: "2021-10-26T12:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "7.2 Cloud technologies: It's OK to ask the business what they feel about it",
	},
	{
		start: "2021-10-26T12:00+01:00",
		end: "2021-10-26T13:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "8.2 Scaling the hill: Personal experiences with IRAM2",
	},
	{
		start: "2021-10-26T15:00+01:00",
		end: "2021-10-26T16:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "9.2 Data-driven security risk reporting as a means to justify security investments",
	},
	{
		start: "2021-10-26T16:00+01:00",
		end: "2021-10-26T17:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "10.2 Manage risks fast, fail faster and adapt fastest",
	},
	{
		start: "2021-10-26T19:00+01:00",
		end: "2021-10-26T20:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "6.2 Backdoors and breaches: Simulating cyber security incidents",
	},
	{
		start: "2021-10-26T20:00+01:00",
		end: "2021-10-26T21:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "7.2 Cloud technologies: It's OK to ask the business what they feel about it",
	},
	{
		start: "2021-10-26T22:00+01:00",
		end: "2021-10-26T23:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "8.2 Scaling the hill: Personal experiences with IRAM2",
	},
	{
		start: "2021-10-26T23:00+01:00",
		end: "2021-10-26T23:59+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "9.2 Data-driven security risk reporting as a means to justify security investments",
	},
	{
		start: "2021-10-27T00:00+01:00",
		end: "2021-10-27T01:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "10.2 Manage risks fast, fail faster and adapt fastest",
	},
	{
		start: "2021-10-27T02:00+01:00",
		end: "2021-10-27T03:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "6.2 Backdoors and breaches: Simulating cyber security incidents",
	},
	{
		start: "2021-10-27T03:00+01:00",
		end: "2021-10-27T04:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "7.2 Cloud technologies: It's OK to ask the business what they feel about it",
	},
	{
		start: "2021-10-27T04:00+01:00",
		end: "2021-10-27T05:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "8.2 Scaling the hill: Personal experiences with IRAM2",
	},
	{
		start: "2021-10-27T07:00+01:00",
		end: "2021-10-27T08:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "9.2 Data-driven security risk reporting as a means to justify security investments",
	},
	{
		start: "2021-10-27T08:00+01:00",
		end: "2021-10-27T09:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "10.2 Manage risks fast, fail faster and adapt fastest",
	},
	{
		start: "2021-10-27T09:00+01:00",
		end: "2021-10-27T10:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "11.2 Transferring risk: The critical role of cyber insurance",
	},
	{
		start: "2021-10-27T10:00+01:00",
		end: "2021-10-27T11:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "12.2 Working against the clock: Fighting cyber fraud",
	},
	{
		start: "2021-10-27T11:00+01:00",
		end: "2021-10-27T12:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "13.2 Enhancing and visualising data driven, risk management, decision making for ICS",
	},
	{
		start: "2021-10-27T14:00+01:00",
		end: "2021-10-27T15:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "14.2 Privacy in practice: Cutting through the noise",
	},
	{
		start: "2021-10-27T15:00+01:00",
		end: "2021-10-27T16:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "15.2 Lessons and insights:  Automated vulnerability and patch management in real time",
	},
	{
		start: "2021-10-27T18:00+01:00",
		end: "2021-10-27T19:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "11.2 Transferring risk: The critical role of cyber insurance",
	},
	{
		start: "2021-10-27T19:00+01:00",
		end: "2021-10-27T20:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "12.2 Working against the clock: Fighting cyber fraud",
	},
	{
		start: "2021-10-27T21:00+01:00",
		end: "2021-10-27T22:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "13.2 Enhancing and visualising data driven, risk management, decision making for ICS",
	},
	{
		start: "2021-10-27T22:00+01:00",
		end: "2021-10-27T23:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "14.2 Privacy in practice: Cutting through the noise",
	},
	{
		start: "2021-10-27T23:00+01:00",
		end: "2021-10-27T23:59+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "15.2 Lessons and insights:  Automated vulnerability and patch management in real time",
	},
	{
		start: "2021-10-28T02:00+01:00",
		end: "2021-10-28T03:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "11.2 Transferring risk: The critical role of cyber insurance",
	},
	{
		start: "2021-10-28T03:00+01:00",
		end: "2021-10-28T04:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "12.2 Working against the clock: Fighting cyber fraud",
	},
	{
		start: "2021-10-28T05:00+01:00",
		end: "2021-10-28T06:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "13.2 Enhancing and visualising data driven, risk management, decision making for ICS",
	},
	{
		start: "2021-10-28T06:00+01:00",
		end: "2021-10-28T07:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "14.2 Privacy in practice: Cutting through the noise",
	},
	{
		start: "2021-10-28T07:00+01:00",
		end: "2021-10-28T08:00+01:00",
		room: "Breakout Two",
		path: "/breakout-two",
		title: "15.2 Lessons and insights:  Automated vulnerability and patch management in real time",
	},
	{
		start: "2021-10-25T10:00+01:00",
		end: "2021-10-25T11:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "1.3 Crowdsourcing information security",
	},
	{
		start: "2021-10-25T11:00+01:00",
		end: "2021-10-25T12:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "2.3 Transforming security into a business partner",
	},
	{
		start: "2021-10-25T12:00+01:00",
		end: "2021-10-25T13:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "3.3 Risk Practice: the next generation – ISF Learning seminar",
	},
	{
		start: "2021-10-25T15:00+01:00",
		end: "2021-10-25T16:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "4.3 CybelAngel - Breaking the Chain: Hindering Ransomware’s Killchain",
	},
	{
		start: "2021-10-25T19:00+01:00",
		end: "2021-10-25T20:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "1.3 Crowdsourcing information security",
	},
	{
		start: "2021-10-25T20:00+01:00",
		end: "2021-10-25T21:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "2.3 Transforming security into a business partner",
	},
	{
		start: "2021-10-25T22:00+01:00",
		end: "2021-10-25T23:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "3.3 Risk Practice: the next generation – ISF Learning seminar",
	},
	{
		start: "2021-10-25T23:00+01:00",
		end: "2021-10-25T23:59+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "4.3 CybelAngel - Breaking the Chain: Hindering Ransomware’s Killchain",
	},
	{
		start: "2021-10-26T03:00+01:00",
		end: "2021-10-26T04:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "1.3 Crowdsourcing information security",
	},
	{
		start: "2021-10-26T04:00+01:00",
		end: "2021-10-26T05:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "2.3 Transforming security into a business partner",
	},
	{
		start: "2021-10-26T05:00+01:00",
		end: "2021-10-26T06:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "3.3 Risk Practice: the next generation – ISF Learning seminar",
	},
	{
		start: "2021-10-26T07:00+01:00",
		end: "2021-10-26T08:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "4.3 CybelAngel - Breaking the Chain: Hindering Ransomware’s Killchain",
	},
	{
		start: "2021-10-26T10:00+01:00",
		end: "2021-10-26T11:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "6.3 Using the SOGP to deliver business-friendly security by design",
	},
	{
		start: "2021-10-26T11:00+01:00",
		end: "2021-10-26T12:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "7.3 Applying the new QIRA methodology: A Ransomware case study",
	},
	{
		start: "2021-10-26T12:00+01:00",
		end: "2021-10-26T13:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "8.3 Cyber Fusion: From buzzword to reality",
	},
	{
		start: "2021-10-26T16:00+01:00",
		end: "2021-10-26T17:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "10.3 You are a bully and your governance sucks: How (not) to shoot yourself in the foot when doing OT cyber security",
	},
	{
		start: "2021-10-26T19:00+01:00",
		end: "2021-10-26T20:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "6.3 Using the SOGP to deliver business-friendly security by design",
	},
	{
		start: "2021-10-26T20:00+01:00",
		end: "2021-10-26T21:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "7.3 Applying the new QIRA methodology: A Ransomware case study",
	},
	{
		start: "2021-10-26T22:00+01:00",
		end: "2021-10-26T23:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "8.3 Cyber Fusion: From buzzword to reality",
	},
	{
		start: "2021-10-27T00:00+01:00",
		end: "2021-10-27T01:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "10.3 You are a bully and your governance sucks: How (not) to shoot yourself in the foot when doing OT cyber security",
	},
	{
		start: "2021-10-27T02:00+01:00",
		end: "2021-10-27T03:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "6.3 Using the SOGP to deliver business-friendly security by design",
	},
	{
		start: "2021-10-27T03:00+01:00",
		end: "2021-10-27T04:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "7.3 Applying the new QIRA methodology: A Ransomware case study",
	},
	{
		start: "2021-10-27T04:00+01:00",
		end: "2021-10-27T05:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "8.3 Cyber Fusion: From buzzword to reality",
	},
	{
		start: "2021-10-27T08:00+01:00",
		end: "2021-10-27T09:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "10.3 You are a bully and your governance sucks: How (not) to shoot yourself in the foot when doing OT cyber security",
	},
	{
		start: "2021-10-27T09:00+01:00",
		end: "2021-10-27T10:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "11.3 Operational Technology Adventures: A Wärtsilä story (security edition)",
	},
	{
		start: "2021-10-27T10:00+01:00",
		end: "2021-10-27T11:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "12.3 ISF Benchmark: Introduction and insights",
	},
	{
		start: "2021-10-27T11:00+01:00",
		end: "2021-10-27T12:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "13.3 IRAM2: Beginning a risk assessment",
	},
	{
		start: "2021-10-27T14:00+01:00",
		end: "2021-10-27T15:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "14.3 Maintaining security in a rapidly changing world",
	},
	{
		start: "2021-10-27T15:00+01:00",
		end: "2021-10-27T16:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "15.3 Quick fire: 2021 Research releases",
	},
	{
		start: "2021-10-27T18:00+01:00",
		end: "2021-10-27T19:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "11.3 Operational Technology Adventures: A Wärtsilä story (security edition)",
	},
	{
		start: "2021-10-27T19:00+01:00",
		end: "2021-10-27T20:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "12.3 ISF Benchmark: Introduction and insights",
	},
	{
		start: "2021-10-27T21:00+01:00",
		end: "2021-10-27T22:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "13.3 IRAM2: Beginning a risk assessment",
	},
	{
		start: "2021-10-27T22:00+01:00",
		end: "2021-10-27T23:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "14.3 Maintaining security in a rapidly changing world",
	},
	{
		start: "2021-10-27T23:00+01:00",
		end: "2021-10-27T23:59+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "15.3 Quick fire: 2021 Research releases",
	},
	{
		start: "2021-10-28T02:00+01:00",
		end: "2021-10-28T03:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "11.3 Operational Technology Adventures: A Wärtsilä story (security edition)",
	},
	{
		start: "2021-10-28T03:00+01:00",
		end: "2021-10-28T04:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "12.3 ISF Benchmark: Introduction and insights",
	},
	{
		start: "2021-10-28T05:00+01:00",
		end: "2021-10-28T06:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "13.3 IRAM2: Beginning a risk assessment",
	},
	{
		start: "2021-10-28T06:00+01:00",
		end: "2021-10-28T07:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "14.3 Maintaining security in a rapidly changing world",
	},
	{
		start: "2021-10-28T07:00+01:00",
		end: "2021-10-28T08:00+01:00",
		room: "Breakout Three",
		path: "/breakout-three",
		title: "15.3 Quick fire: 2021 Research releases",
	},
	{
		start: "2021-10-25T10:00+01:00",
		end: "2021-10-25T11:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "1.4 KPMG - Operational readiness in a moving-target environment",
	},
	{
		start: "2021-10-25T11:00+01:00",
		end: "2021-10-25T12:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "2.4 IBM Security - Security risk quantification: Empowering better business decision making to address security risks",
	},
	{
		start: "2021-10-25T12:00+01:00",
		end: "2021-10-25T13:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "3.4 Veracode - The four innovation drivers for application security",
	},
	{
		start: "2021-10-25T15:00+01:00",
		end: "2021-10-25T16:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "4.4 SentinelOne  - Supply chain attacks are the new high watermark of attacks",
	},
	{
		start: "2021-10-25T16:00+01:00",
		end: "2021-10-25T17:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "5.4 Crowdstrike - Staying in control of your growing attack surface",
	},
	{
		start: "2021-10-25T19:00+01:00",
		end: "2021-10-25T20:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "1.4 KPMG - Operational readiness in a moving-target environment",
	},
	{
		start: "2021-10-25T20:00+01:00",
		end: "2021-10-25T21:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "2.4 IBM Security - Security risk quantification: Empowering better business decision making to address security risks",
	},
	{
		start: "2021-10-25T22:00+01:00",
		end: "2021-10-25T23:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "3.4 Veracode - The four innovation drivers for application security",
	},
	{
		start: "2021-10-25T23:00+01:00",
		end: "2021-10-25T23:59+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "4.4 SentinelOne  - Supply chain attacks are the new high watermark of attacks",
	},
	{
		start: "2021-10-26T00:00+01:00",
		end: "2021-10-26T01:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "5.4 Crowdstrike - Staying in control of your growing attack surface",
	},
	{
		start: "2021-10-26T03:00+01:00",
		end: "2021-10-26T04:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "1.4 KPMG  - Operational readiness in a moving-target environment",
	},
	{
		start: "2021-10-26T04:00+01:00",
		end: "2021-10-26T05:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "2.4 IBM Security - Security risk quantification: Empowering better business decision making to address security risks",
	},
	{
		start: "2021-10-26T05:00+01:00",
		end: "2021-10-26T06:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "3.4 Veracode - The four innovation drivers for application security",
	},
	{
		start: "2021-10-26T07:00+01:00",
		end: "2021-10-26T08:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "4.4 SentinelOne  - Supply chain attacks are the new high watermark of attacks",
	},
	{
		start: "2021-10-26T08:00+01:00",
		end: "2021-10-26T09:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "5.4 Crowdstrike - Staying in control of your growing attack surface",
	},
	{
		start: "2021-10-26T10:00+01:00",
		end: "2021-10-26T11:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "6.4 SureCloud -The organisational shift to continuous compliance",
	},
	{
		start: "2021-10-26T11:00+01:00",
		end: "2021-10-26T12:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "7.4 BitSight  - Why managing vendor risk is an essential part of your security programme",
	},
	{
		start: "2021-10-26T12:00+01:00",
		end: "2021-10-26T13:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "8.4 Huawei Technologies - 5G security standardisation and knowledge base",
	},
	{
		start: "2021-10-26T15:00+01:00",
		end: "2021-10-26T16:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "9.4 BeyondTrust  - The seven perils of privilege",
	},
	{
		start: "2021-10-26T16:00+01:00",
		end: "2021-10-26T17:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "10.4 SecurityScorecard - Trust, Collaborate, and Mitigate: Redefine third-party risk management with actionable insights",
	},
	{
		start: "2021-10-26T19:00+01:00",
		end: "2021-10-26T20:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "6.4 SureCloud -The organisational shift to continuous compliance",
	},
	{
		start: "2021-10-26T20:00+01:00",
		end: "2021-10-26T21:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "7.4 BitSight  - Why managing vendor risk is an essential part of your security programme",
	},
	{
		start: "2021-10-26T22:00+01:00",
		end: "2021-10-26T23:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "8.4 Huawei Technologies - 5G security standardisation and knowledge base",
	},
	{
		start: "2021-10-26T23:00+01:00",
		end: "2021-10-26T23:59+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "9.4 BeyondTrust  - The seven perils of privilege",
	},
	{
		start: "2021-10-27T00:00+01:00",
		end: "2021-10-27T01:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "10.4 SecurityScorecard - Trust, Collaborate, and Mitigate: Redefine third-party risk management with actionable insights",
	},
	{
		start: "2021-10-27T02:00+01:00",
		end: "2021-10-27T03:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "6.4 SureCloud -The organisational shift to continuous compliance",
	},
	{
		start: "2021-10-27T03:00+01:00",
		end: "2021-10-27T04:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "7.4 BitSight  - Why managing vendor risk is an essential part of your security programme",
	},
	{
		start: "2021-10-27T04:00+01:00",
		end: "2021-10-27T05:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "8.4 Huawei Technologies - 5G security standardisation and knowledge base",
	},
	{
		start: "2021-10-27T07:00+01:00",
		end: "2021-10-27T08:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "9.4 BeyondTrust  - The seven perils of privilege",
	},
	{
		start: "2021-10-27T08:00+01:00",
		end: "2021-10-27T09:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "10.4 SecurityScorecard - Trust, Collaborate, and Mitigate: Redefine third-party risk management with actionable insights",
	},
	{
		start: "2021-10-27T09:00+01:00",
		end: "2021-10-27T10:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "11.4 Keysight Technologies - Change your perspective: View your network like a hacker",
	},
	{
		start: "2021-10-27T10:00+01:00",
		end: "2021-10-27T11:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "12.4 Synopsys - The ultimate guide: Reduce risk with your software security initiative",
	},
	{
		start: "2021-10-27T11:00+01:00",
		end: "2021-10-27T12:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "13.4 OneTrust - Supply chain attacks: The rise of ransomware and how to reduce your risk",
	},
	{
		start: "2021-10-27T15:00+01:00",
		end: "2021-10-27T16:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "15.4 Crossword Cybersecurity - Cyber Risk in Supply Chains: The backdrop and managing your programme",
	},
	{
		start: "2021-10-27T18:00+01:00",
		end: "2021-10-27T19:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "11.4 Keysight Technologies - Change your perspective: View your network like a hacker",
	},
	{
		start: "2021-10-27T19:00+01:00",
		end: "2021-10-27T20:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "12.4 Synopsys - The ultimate guide: Reduce risk with your software security initiative",
	},
	{
		start: "2021-10-27T21:00+01:00",
		end: "2021-10-27T22:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "13.4 OneTrust - Supply chain attacks: The rise of ransomware and how to reduce your risk",
	},
	{
		start: "2021-10-27T23:00+01:00",
		end: "2021-10-27T23:59+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "15.4 Crossword Cybersecurity - Cyber Risk in Supply Chains: The backdrop and managing your programme",
	},
	{
		start: "2021-10-28T02:00+01:00",
		end: "2021-10-28T03:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "11.4 Keysight Technologies - Change your perspective: View your network like a hacker",
	},
	{
		start: "2021-10-28T03:00+01:00",
		end: "2021-10-28T04:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "12.4 Synopsys - The ultimate guide: Reduce risk with your software security initiative",
	},
	{
		start: "2021-10-28T05:00+01:00",
		end: "2021-10-28T06:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "13.4 OneTrust - Supply chain attacks: The rise of ransomware and how to reduce your risk",
	},
	{
		start: "2021-10-28T07:00+01:00",
		end: "2021-10-28T08:00+01:00",
		room: "Breakout Four",
		path: "/breakout-four",
		title: "15.4 Crossword Cybersecurity - Cyber Risk in Supply Chains: The backdrop and managing your programme",
	},
]

export const breakout1Agenda = allAgendas.filter(event => event.room === "Breakout One")

export const breakout2Agenda = allAgendas.filter(event => event.room === "Breakout Two")

export const breakout3Agenda = allAgendas.filter(event => event.room === "Breakout Three")

export const breakout4Agenda = allAgendas.filter(event => event.room === "Breakout Four")

export const auditoriumAgenda = allAgendas.filter(event => event.room === "Auditorium")